import { IUserDepricated } from "@mctypes/global.types";
import React from "react";
import { Avatar } from "../../../../../components";
import { Flex } from "@mantine/core";


const IssueTableUserCellRenderer: React.FC<{ user: IUserDepricated }> = ({ user }) => {
  return user != null ? (
    <Flex style={{ alignItems: "center" }}>
      <Avatar id={user._id} name={user.name} />
      <div style={{ marginLeft: "0.5rem" }}>{user.name}</div>
    </Flex>
  ) : (
    <div />
  );
};

export default IssueTableUserCellRenderer;
